export default [
    { //股权融资项目列表
        path: '/equityManagement/productList',
        name:'equityManagementProductList',
        meta: { title: '股权融资项目列表'},
        component: () => import('../../views/equityManagement/productList.vue')
    },
    { //项目明细
        path: '/equityManagement/productDetail',
        name:'equityManagementProductDetail',
        meta: { title: '项目明细'},
        component: () => import('../../views/equityManagement/productDetail.vue')
    },
    { //基金合作申请列表
        path: '/equityManagement/applyList',
        name:'equityManagementApplyList',
        meta: { title: '基金合作申请列表'},
        component: () => import('../../views/equityManagement/applyList.vue')
    },
    { //基金合作申请详情
      path: '/equityManagement/applyList/detail/:type',
      name:'equityManagementApplyListDetail',
      meta: { title: '基金合作申请详情'},
      component: () => import('../../views/equityManagement/applyListDetail.vue')
  }
]